/* eslint-disable no-unused-expressions */
import { PUT_APPLICATION } from '@cogitate/ui-multi-utils';
import { storeKeys } from 'ui/data/constants/keys';
import { processPayload } from 'ui/utilities/helper';

export const pageStateAction = (state, reset) => (dispatch, getState) => {
  const appData = getState()[storeKeys.ApplicationReducer];
  const newState = { ...appData.currentState, ...state };

  dispatch({
    type: PUT_APPLICATION,
    payload: { ...appData, currentState: reset ? {} : newState },
  });
};

export const masterModalHelper = (action, lob, payload = [], callbacks = {}) => {
  let newAction;
  if (lob) {
    const lobModule = require('ui/redux/actions/' + lob);
    newAction = lobModule[Object.keys(lobModule).find((key) => key === action)];
  }
  // else {
  //   const lobModule = require("ui/redux/actions/common");
  //   newAction = lobModule[Object.keys(lobModule).find((key) => key == action)];
  // }
  // console.log('masterModalHelper', action, newAction);
  if (!newAction) {
    // Handle the case where newAction is not found.
    return;
  }

  const result = newAction(...payload);
  // Use a thenable check for robustness.
  if (result && typeof result.then === 'function' && callbacks) {
    return result
      .then((data) => {
        return callbacks.onComplete ? callbacks.onComplete(data) : data;
      })
      .catch((err) => {
        return callbacks.onError ? callbacks.onError(err) : Promise.reject(err);
      });
  } else if (result !== undefined) {
    return result;
  }
};

export const masterAction = (dispatch, action, lob, payload, schemaData, saveAndExit, onComplete = () => {}) => {
  let newAction;
  if (lob) {
    const lobModule = require('ui/redux/actions/' + lob);
    newAction = lobModule[Object.keys(lobModule).find((key) => key === action)];
  }
  // console.log('masterAction', action, newAction);
  // else {
  //   const lobModule = require("ui/redux/actions/common");
  //   newAction = lobModule[Object.keys(lobModule).find((key) => key == action)];
  // }

  if (!newAction) {
    return;
  }

  payload = processPayload(payload);
  const promise = dispatch(
    newAction({
      payload,
      lob,
      schemaData,
      saveAndExit,
      onComplete,
    })
  );
  if (promise) {
    promise
      .then((data) => {
        const { executeCallback = true } = data || {};
        if (executeCallback === false) {
          return;
        }
        // setCurrentPolicy();
        onComplete(data);
      })
      .catch((error) => {
        console.error(action, error);
      });
  }
};

export const masterModalAction = (action, lob, payload, callbacks) => {
  let newAction;

  if (lob) {
    const lobModule = require('ui/redux/actions/modal/' + lob);
    newAction = lobModule[Object.keys(lobModule).find((key) => key === action)];
  } else {
    const lobModule = require('ui/redux/actions/modal/common');
    newAction = lobModule[Object.keys(lobModule).find((key) => key === action)];
  }

  if (!newAction) {
    return;
  }

  const promise = newAction(...payload);

  if (promise instanceof Promise && callbacks) {
    promise
      .then((data) => {
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        callbacks?.onComplete && callbacks?.onComplete(data);
      })
      .catch((err) => {
        // eslint-disable-next-line @typescript-eslint/no-unused-expressions
        callbacks?.onError && callbacks?.onError(err);
      });
  } else if (promise !== undefined) {
    return promise;
  }
};

export const resetPageStateAction = (state) => (dispatch, getState) => {
  const appData = getState()[storeKeys.ApplicationReducer];
  dispatch({
    type: PUT_APPLICATION,
    payload: { ...appData, currentState: state },
  });
};
